export const ON_CHANGE_FORM = 'ON_CHANGE_FORM'
export const ON_PAUSE = 'ON_PAUSE'
export const ON_START_DESIGN = 'ON_START_DESIGN'
export const ON_FINFISH_TIMER = 'ON_FINFIS_TIMER'
export const ON_TICK = 'ON_TICK'
export const ON_TICK_PAUSE = 'ON_TICK_PAUSE'
export const ON_TICK_FINAL = 'ON_TICK_FINAL'
export const ON_FINAL_FORM = 'ON_FINAL_FORM'
export const ON_FINISH = 'ON_FINISH'
export const ON_FINIFSH_FORM = 'ON_FINIFSH_FORMH'

export const ON_PREPAUSE = 'ON_PREPAUSE'
export const ON_PREPAUSE_FINISH = 'ON_PREPAUSE_FINISH'

export const POST_FORM_REQUEST = 'POST_FORM/REQUEST'
export const POST_FORM_SUCCESS = 'POST_FORM/SUCCESS'
export const POST_FORM_ERROR = 'POST_FORM/ERROR'

export const POST_FORM_DESIGN_REQUEST = 'POST_FORM_DESIGN/REQUEST'
export const POST_FORM_DESIGN_SUCCESS = 'POST_FORM_DESIGN/SUCCESS'
export const POST_FORM_DESIGN_ERROR = 'POST_FORM_DESIGN/ERROR'


export const STATE_ID = window.STATE_ID || "state2"

const localState = localStorage.getItem(STATE_ID)

export const PAUSE_DURATION = (window.PAUSE_DURATION || 1) * 60000
export const TWO_HOURS_DURATION = (window.TWO_HOURS_DURATION || 1) * 60000 //1000//7200000

const pauseMinutes = new Date(PAUSE_DURATION)

const initialState = { 
  step: 0,
  hours: 2,
  counter: '2:00’00', 
  leftPause: PAUSE_DURATION,
  pauseMinutes: pauseMinutes.getMinutes(),
  form: {
    disabled: true,
  }
}
// if(initialState.startedAt && typeof initialState.startedAt === 'string') initialState.startedAt = new Date(initialState.startedAt)
// if(initialState.finalAt && typeof initialState.finalAt === 'string') initialState.finalAt = new Date(initialState.finalAt)
document.querySelector('body').style.minHeight = '1620px'
export default (state = initialState, action) => {

  switch (action.type) {
    case ON_CHANGE_FORM:
      const form = { ...state.form, ...action.payload }
      return { 
        ...state,
        form: { ...form, 
          disabled: !(form.checked && form.emailIsValid === '' && form.nameIsValid === '' && form.portfolio0IsValid === ''),
          disabledFinal: !(form.checkedFinal&& form.emailIsValid === '' && form.nameIsValid === '' && form.task0IsValid === '' && form.task1IsValid === '' && form.task2IsValid === '') } 
        }
    case POST_FORM_REQUEST:
        document.querySelector('#root').style.minHeight = `${document.querySelector('#root').clientHeight}px`
      return { ...state, form: { ...state.form, loading: true } } 
    case POST_FORM_SUCCESS:
      document.querySelector('.brief_link').scrollIntoView({ block: "start", behavior: "smooth" })

      return { ...state, form: { ...state.form, loading: false }, step: 1 } 
    case POST_FORM_ERROR:
      return { ...state, form: { ...state.form, loading: false, error: { ...action.payload } } }
    case ON_START_DESIGN:
      return { startedAt: new Date(), ...state, step: 2, paused: false, ...action.payload }
    case ON_FINAL_FORM:
      return { finalAt: new Date(), ...state, step: 4, paused: false, counter: `0:04’59` }

    case ON_PAUSE:
      return { ...state, step: 2, paused: !state.paused } 
    case ON_TICK:
      return { ...state, ...action.payload } 
    case ON_TICK_FINAL:
      return { ...state, ...action.payload } 
    case ON_TICK_PAUSE:
      const pauseMinutes = new Date(action.payload.leftPause + (!action.payload.leftPause ? 0 : (60000 - action.payload.leftPause%60000)))
      // console.log()
      return { ...state, ...action.payload, pauseMinutes: pauseMinutes.getMinutes() } 
    
    case ON_PREPAUSE:
      return { ...state, ...action.payload } 

    case POST_FORM_DESIGN_REQUEST:
      return { ...state, form: { ...state.form, loading: true } } 
    case POST_FORM_DESIGN_SUCCESS: case ON_FINISH:
        document.querySelector('body').scrollIntoView({
          block: "start",
          behavior: "smooth"
        })
        const finishState = { ...state, form: { ...state.form, loading: false }, ...action.payload }
        localStorage.setItem(STATE_ID, JSON.stringify(finishState))
      return finishState
    case POST_FORM_DESIGN_ERROR:
      return { ...state, form: { ...state.form, loading: false, error: { ...action.payload } } }
    
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app.js